import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import { FilterUrlService } from './filter-url.service';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { Users } from '../model/Users';

@Injectable()
export class UsersService {
  url:string = GLOBAL.url+"users";
  filter:string;

  constructor( private http:HttpClient, private _urlService:FilterUrlService ) {
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }
  /**
  * Obtiene el listado de 10 elementos.
  * @return listado de clientes o un error.
  */
  public get(){
    return this.http.get(this.url+"?sort=-prefix" ).map( res => {
      return res;
    });
  }

  public getDataFiltered(filters){
    let url = this.url+filters;
    console.log(url);
    return this.http.get(url).map( res => {
        return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado de clientes o un error.
  */
  public getUsersByRol(type:number){
    let url = GLOBAL.url+'roles/'+type+'/users';
    return this.http.get(url ).map( res => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/users.service.ts